<div class="user-management-container">

  <!-- Toolbar -->
  <mat-card class="um-toolbar-card">
    <mat-card-content class="um-toolbar">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchTerm" (input)="filterUsers()"
               placeholder="Name, login, team, role...">
        <mat-icon matPrefix>search</mat-icon>
        <button *ngIf="searchTerm" matSuffix mat-icon-button (click)="searchTerm=''; filterUsers()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <span class="toolbar-spacer"></span>

      <button mat-raised-button color="primary" (click)="openAddModal()">
        <mat-icon>add</mat-icon>
        Add User
      </button>

      <button
        *ngIf="canDeleteParticipants"
        mat-raised-button
        color="warn"
        (click)="requestDeleteSelected()"
        [disabled]="!hasSelection || isDeletingUsers">
        <mat-icon>delete</mat-icon>
        Delete Selected ({{ selection.selected.length }})
      </button>
    </mat-card-content>
  </mat-card>

  <!-- List View -->
  <div *ngIf="viewMode === 'detail'" class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" class="users-table">

      <!-- Select Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            *ngIf="canDeleteParticipants"
            [checked]="allEligibleRowsSelected()"
            [indeterminate]="hasSelection && !allEligibleRowsSelected()"
            (change)="masterToggle()"
            matTooltip="Select participant-only users">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let user">
          <mat-checkbox
            *ngIf="canDeleteParticipants"
            [checked]="isSelected(user)"
            [disabled]="!isDeletionEligible(user)"
            (change)="toggleUserSelection(user)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let user">
          <div class="user-info">
            <div class="user-avatar">{{user.name?.substring(0,1) || 'U'}}</div>
            <span>{{user.name}}</span>
          </div>
        </td>
      </ng-container>

      <!-- Login ID Column -->
      <ng-container matColumnDef="loginId">
        <th mat-header-cell *matHeaderCellDef>Login ID</th>
        <td mat-cell *matCellDef="let user">{{user.loginId}}</td>
      </ng-container>

      <!-- Teams Column -->
      <ng-container matColumnDef="teams">
        <th mat-header-cell *matHeaderCellDef>Teams</th>
        <td mat-cell *matCellDef="let user">
          <div class="teams-cell">
            <ng-container *ngIf="user.teams && user.teams.length > 0">
              <mat-chip-set>
                <mat-chip *ngFor="let team of user.teams"
                          [highlighted]="team.isPrimary"
                          [class.primary-chip]="team.isPrimary">
                  {{team.team}}
                  <mat-icon *ngIf="team.isPrimary" matChipTrailingIcon>star</mat-icon>
                </mat-chip>
              </mat-chip-set>
            </ng-container>
            <span *ngIf="!user.teams || user.teams.length === 0" class="no-team">
              {{user.team || 'No team'}}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Roles Column -->
      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef>Roles</th>
        <td mat-cell *matCellDef="let user">
          <mat-chip-set>
            <mat-chip *ngFor="let role of user.roles">{{role}}</mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let user">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openEditModal(user)" [disabled]="user.isSystemUser">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="openDetailModal(user)">
              <mat-icon>visibility</mat-icon>
              <span>View Details</span>
            </button>
            <button mat-menu-item *ngIf="user.isSystemUser" disabled>
              <mat-icon>lock</mat-icon>
              <span>Protected User</span>
            </button>
            <button
              mat-menu-item
              *ngIf="canDeleteParticipants"
              [disabled]="!isDeletionEligible(user) || isDeletingUsers"
              (click)="deleteUser(user)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      appPersistPageSize="users:list"
      showFirstLastButtons
      aria-label="Select page of users">
    </mat-paginator>
  <!-- Grid View -->
  <div *ngIf="isCardView" class="users-grid">
    <mat-card *ngFor="let user of dataSource.data" class="user-card mat-elevation-z2">
      <mat-card-header>
        <div mat-card-avatar class="user-card-avatar">
          {{user.name.substring(0,1) || 'U'}}
        </div>
        <mat-card-title>{{user.name}}</mat-card-title>
        <mat-card-subtitle>{{user.loginId}}</mat-card-subtitle>
        <button mat-icon-button [matMenuTriggerFor]="cardMenu" class="card-menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #cardMenu="matMenu">
          <button mat-menu-item (click)="openEditModal(user)" [disabled]="user.isSystemUser">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="openDetailModal(user)">
            <mat-icon>visibility</mat-icon>
            <span>View Details</span>
          </button>
        </mat-menu>
      </mat-card-header>

      <mat-card-content>
        <div class="card-section">
          <mat-icon class="section-icon">groups</mat-icon>
          <div class="section-content">
            <label>Teams</label>
            <mat-chip-set *ngIf="user.teams && user.teams.length > 0">
              <mat-chip *ngFor="let team of user.teams"
                        [highlighted]="team.isPrimary"
                        [class.primary-chip]="team.isPrimary">
                {{team.team}}
                <mat-icon *ngIf="team.isPrimary" matChipTrailingIcon>star</mat-icon>
              </mat-chip>
            </mat-chip-set>
            <span *ngIf="!user.teams || user.teams.length === 0" class="no-data">
              {{user.team || 'No team'}}
            </span>
          </div>
        </div>

        <div class="card-section">
          <mat-icon class="section-icon">badge</mat-icon>
          <div class="section-content">
            <label>Roles</label>
            <mat-chip-set>
              <mat-chip *ngFor="let role of user.roles">{{role}}</mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner></mat-spinner>
  </div>

  <!-- Add/Edit User Dialog -->
  <div class="dialog-backdrop" *ngIf="showAddModal || showEditModal" (click)="closeModals()"></div>

  <mat-card *ngIf="showAddModal || showEditModal" class="user-dialog mat-elevation-z8">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>{{isEditMode ? 'edit' : 'person_add'}}</mat-icon>
        {{isEditMode ? 'Edit User' : 'Add User'}}
      </mat-card-title>
      <button mat-icon-button class="close-button" (click)="closeModals()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="form-container">

          <!-- Login ID -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Login ID (Email)</mat-label>
            <input matInput type="email" formControlName="loginId" placeholder="user@example.com">
            <mat-icon matPrefix>email</mat-icon>
            <mat-error *ngIf="userForm.get('loginId')?.hasError('required')">
              Login ID is required
            </mat-error>
            <mat-error *ngIf="userForm.get('loginId')?.hasError('email')">
              Please enter a valid email
            </mat-error>
          </mat-form-field>

          <!-- Password -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" placeholder="Enter password">
            <mat-icon matPrefix>lock</mat-icon>
            <mat-error *ngIf="userForm.get('password')?.hasError('required')">
              Password is required
            </mat-error>
            <mat-error *ngIf="userForm.get('password')?.hasError('minlength')">
              Password must be at least 3 characters
            </mat-error>
          </mat-form-field>

          <!-- Name -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" placeholder="Enter full name">
            <mat-icon matPrefix>person</mat-icon>
            <mat-error *ngIf="userForm.get('name')?.hasError('required')">
              Name is required
            </mat-error>
          </mat-form-field>

          <!-- Teams with Autocomplete and Chips -->
          <div class="teams-section full-width">
            <label class="section-label">
              <mat-icon>groups</mat-icon>
              Teams
            </label>

            <mat-form-field appearance="outline" class="team-autocomplete">
              <mat-label>Add teams</mat-label>
              <mat-chip-grid #chipGrid>
                <mat-chip-row *ngFor="let team of selectedTeams; let i = index"
                              (removed)="removeTeamFromUser(i)"
                              (click)="setPrimaryTeam(i)"
                              [highlighted]="team.isPrimary"
                              style="cursor: pointer;"
                              [matTooltip]="team.isPrimary ? 'Primary team' : 'Click to set as primary'">
                  <mat-icon *ngIf="team.isPrimary" matChipAvatar>star</mat-icon>
                  {{team.team}}
                  <button matChipRemove (click)="$event.stopPropagation()">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>

              <input placeholder="Search and select teams..."
                     #teamInput
                     [formControl]="teamCtrl"
                     [matChipInputFor]="chipGrid"
                     [matAutocomplete]="autoTeam"
                     (focus)="onTeamInputFocus()"
                     (click)="onTeamInputFocus()">

              <mat-icon matSuffix>search</mat-icon>

              <mat-autocomplete #autoTeam="matAutocomplete"
                                autoActiveFirstOption
                                panelClass="team-autocomplete-panel"
                                (optionSelected)="selectTeam($event)">
                <mat-option *ngFor="let team of filteredTeams | async" [value]="team.id">
                  {{team.name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-hint *ngIf="selectedTeams.length > 0">Click on a team chip to set it as primary</mat-hint>

            <mat-error *ngIf="selectedTeams.length === 0 && userForm.get('teams')?.touched">
              At least one team is required
            </mat-error>
          </div>

          <!-- Roles -->
          <div class="roles-section full-width">
            <label class="section-label">
              <mat-icon>badge</mat-icon>
              Roles
            </label>

            <mat-form-field appearance="outline" class="role-autocomplete">
              <mat-label>Add roles</mat-label>
              <mat-chip-grid #roleChipGrid>
                <mat-chip-row *ngFor="let role of selectedRoles; let i = index"
                              (removed)="removeRole(i)">
                  {{role}}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>

              <input placeholder="Search and select roles..."
                     #roleInput
                     [formControl]="roleCtrl"
                     [matChipInputFor]="roleChipGrid"
                     [matAutocomplete]="autoRole"
                     (focus)="onRoleInputFocus()"
                     (click)="onRoleInputFocus()">

              <mat-icon matSuffix>search</mat-icon>

              <mat-autocomplete #autoRole="matAutocomplete"
                                autoActiveFirstOption
                                panelClass="role-autocomplete-panel"
                                (optionSelected)="selectRole($event)">
                <mat-option *ngFor="let role of filteredRoles | async" [value]="role.value">
                  {{role.label}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-error *ngIf="selectedRoles.length === 0 && userForm.get('roles')?.touched">
              At least one role is required
            </mat-error>
          </div>

        </div>
      </form>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-button (click)="closeModals()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="loading">
        <mat-icon>{{isEditMode ? 'save' : 'add'}}</mat-icon>
        {{isEditMode ? 'Update' : 'Create'}}
      </button>
    </mat-card-actions>
  </mat-card>

  <!-- Detail View Dialog -->
  <div class="dialog-backdrop" *ngIf="showDetailModal" (click)="closeModals()"></div>

  <mat-card *ngIf="showDetailModal" class="detail-dialog mat-elevation-z8">
    <mat-card-header>
      <div mat-card-avatar class="detail-avatar">
        {{selectedUser?.name?.substring(0,1) || 'U'}}
      </div>
      <mat-card-title>{{selectedUser?.name}}</mat-card-title>
      <mat-card-subtitle>{{selectedUser?.loginId}}</mat-card-subtitle>
      <button mat-icon-button class="close-button" (click)="closeModals()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <mat-list>
        <mat-list-item>
          <mat-icon matListItemIcon>email</mat-icon>
          <div matListItemTitle>Login ID</div>
          <div matListItemLine>{{selectedUser?.loginId}}</div>
        </mat-list-item>

        <mat-divider></mat-divider>

        <mat-list-item>
          <mat-icon matListItemIcon>groups</mat-icon>
          <div matListItemTitle>Teams</div>
          <div matListItemLine>
            <mat-chip-set *ngIf="selectedUser && selectedUser.teams && selectedUser.teams.length > 0">
              <mat-chip *ngFor="let team of selectedUser!.teams"
                        [highlighted]="team.isPrimary"
                        [class.primary-chip]="team.isPrimary">
                {{team.team}}
                <mat-icon *ngIf="team.isPrimary" matChipTrailingIcon>star</mat-icon>
              </mat-chip>
            </mat-chip-set>
            <span *ngIf="!selectedUser || !selectedUser.teams || selectedUser.teams.length === 0">
              {{selectedUser?.team || 'No team'}}
            </span>
          </div>
        </mat-list-item>

        <mat-divider></mat-divider>

        <mat-list-item>
          <mat-icon matListItemIcon>badge</mat-icon>
          <div matListItemTitle>Roles</div>
          <div matListItemLine>
            <mat-chip-set>
              <mat-chip *ngFor="let role of selectedUser?.roles">{{role}}</mat-chip>
            </mat-chip-set>
          </div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-button (click)="closeModals()">Close</button>
      <button mat-raised-button color="primary" (click)="openEditModal(selectedUser!); showDetailModal = false"
              [disabled]="selectedUser?.isSystemUser">
        <mat-icon>edit</mat-icon>
        Edit User
      </button>
    </mat-card-actions>
  </mat-card>

</div>
